import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 9.86v4.28L14.97 12 18 9.86m-9 0v4.28L5.97 12 9 9.86M20 6l-8.5 6 8.5 6V6zm-9 0l-8.5 6 8.5 6V6z"
}), 'FastRewindOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FastRewindOutlined.js
// module id = 3510
// module chunks = 2